import { createCustomAction } from 'typesafe-actions';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$CHANGE_OPEN_PURCHASE_ITEM/REQUESTED';
const BLOCKED = '$CHANGE_OPEN_PURCHASE_ITEM/BLOCKED';
const APPROVED = '$CHANGE_OPEN_PURCHASE_ITEM/APPROVED';
const SUCCEEDED = '$CHANGE_OPEN_PURCHASE_ITEM/SUCCEEDED';
const FAILED = '$CHANGE_OPEN_PURCHASE_ITEM/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      itemId: string;
    }>(type);
};

const succeed = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      purchase: _Purchase;
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, succeed),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
